export default __webpack_public_path__ + "static/media/category-financial.991817b7.jpg";